export const customers = [
  {
    clientCode: 'CL01977',
    companyName: 'Client CL01977',
    companyGroup: 'CL01977',
    companyAddress: 'str. -, nr. 6A',
    cui: '1234',
    creditExpiryDate: '2022-12-31T00:00:00',
    companyMailAddress: 'str. -, nr. 6A',
    commerceRegistrationNumber: '-',
    clientStatus: '_blank_',
    columnConfigurationCardSettings: null,
    columnConfigurationCardTransactions: null,
    creditLimit: 130000,
    opLimit: 0,
    temporaryLimit: 0,
    clientBalance: 52301.89,
    clientDueBalance: 52301.89,
    outstandingOrders: 0,
    cardTransactionBalance: 30913.58,
    availableCreditLimit: 0,
    salesConsultantCode: 'DC',
    backOfficeResponsibleCode: 'CE'
  },
  {
    clientCode: 'CL01901',
    companyName: 'ART TRUCK ENERGY SRL',
    companyGroup: 'CL01977',
    companyAddress: 'str. -, nr. 6A',
    cui: '1234',
    creditExpiryDate: '2022-12-31T00:00:00',
    companyMailAddress: 'str. -, nr. 6A',
    commerceRegistrationNumber: '-',
    clientStatus: '_blank_',
    columnConfigurationCardSettings: null,
    columnConfigurationCardTransactions: null,
    creditLimit: 130000,
    opLimit: 0,
    temporaryLimit: 0,
    clientBalance: 52301.89,
    clientDueBalance: 52301.89,
    outstandingOrders: 0,
    cardTransactionBalance: 30913.58,
    availableCreditLimit: 0,
    salesConsultantCode: 'DC',
    backOfficeResponsibleCode: 'CE'
  },
  {
    clientCode: 'CL01902',
    companyName: 'OIL ENERGY SRL',
    companyGroup: 'CL01977',
    companyAddress: 'str. -, nr. 6A',
    cui: '1234',
    creditExpiryDate: '2022-12-31T00:00:00',
    companyMailAddress: 'str. -, nr. 6A',
    commerceRegistrationNumber: '-',
    clientStatus: '_blank_',
    columnConfigurationCardSettings: null,
    columnConfigurationCardTransactions: null,
    creditLimit: 130000,
    opLimit: 0,
    temporaryLimit: 0,
    clientBalance: 52301.89,
    clientDueBalance: 52301.89,
    outstandingOrders: 0,
    cardTransactionBalance: 30913.58,
    availableCreditLimit: 0,
    salesConsultantCode: 'DC',
    backOfficeResponsibleCode: 'CE'
  }
];

export const customer = {
  clientCode: 'CL01977',
  companyName: 'Client CL01977',
  companyGroup: 'CL01977',
  companyAddress: 'str. -, nr. 6A',
  cui: '1234',
  creditExpiryDate: '2022-12-31T00:00:00',
  companyMailAddress: 'str. -, nr. 6A',
  commerceRegistrationNumber: '-',
  clientStatus: '_blank_',
  columnConfigurationCardSettings: null,
  columnConfigurationCardTransactions: null,
  creditLimit: 130000,
  opLimit: 0,
  temporaryLimit: 0,
  clientBalance: 52301.89,
  clientDueBalance: 52301.89,
  outstandingOrders: 0,
  cardTransactionBalance: 30913.58,
  availableCreditLimit: 0,
  salesConsultantCode: 'DC',
  backOfficeResponsibleCode: 'CE'
};

export const responsibles = [
  {
    code: 'DC',
    name: 'AAA',
    phoneNumber: '0720091365',
    emailAddress: 'alexandra@artoil.ro'
  },
  {
    code: 'CE',
    name: 'AAA',
    phoneNumber: '0730657095',
    emailAddress: 'backoffice03@artoil.ro'
  }
];
